<template>
  <div 
    class="scan-region"
    :style="{
      'top': `${(top - margin)*100}%`,
      'left': `${(left - margin)*100}%`,
      'width': `${(width + 2*margin)*100}%`,
      'height': `${(height + 2*margin)*100}%`
    }"

    :class="{
      'scan-region--medium-probability': probability > 60 && probability < 80,
      'scan-region--low-probability': probability <= 60 && probability > 40,
      'scan-region--no-probability': probability <= 40
    }"
  >
    <span class="scan-region__value">{{ this.value }}</span>
  </div>
</template>

<script>
export default {
  name: "scan-preview",
  data() {
    return {
      margin: 0.004
    }
  },
  props: {
    top: Number,
    left: Number,
    width: Number,
    height: Number,
    probability: Number,
    value: String
  }
}
</script>


<style lang="scss" scoped>
  .scan-region {
    background-color: rgba($primaryColor, 0.5);
    border: solid 1px $primaryColor;
    position: absolute;
    transition: background-color 0.3s ease-in-out;
    box-sizing: border-box;

    &:hover {
      background-color: rgba($primaryColor, 0.6);
    }

    &__value {
      position: absolute;
      top: -16px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      padding: 3px;
      font-size: 0.7em;
      color: #333;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s;
      border-radius: 3px;
      box-shadow: 1px 1px 6px rgba(#000, 0.16);
      // max-width: 200px;
      white-space: nowrap;
    }

    &:hover &__value {
      opacity: 1;
      visibility: visible;
      top: -26px;
    }

    &--medium-probability {
      border-color: orange;
      background-color: rgba(orange, 0.5);

      &:hover {
        background-color: rgba(orange, 0.6);
      }
    }

    &--low-probability {
      border-color: firebrick;
      background-color: rgba(firebrick, 0.5);

      &:hover {
        background-color: rgba(firebrick, 0.6);
      }
    }

    &--no-probability {
      display: none;
    }
  }
</style>
